import React, { useState } from 'react';
import { Plus, Calendar } from 'lucide-react';
import { getUpcomingAnniversaries } from '../utils/DateUtils';
import AnniversaryCard from './AnniversaryCard';
import AddAnniversaryForm from './AddAnniversary';
import '../Counter.css';

const AnniversariesSection = ({ anniversaries, onAdd, onDelete }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const upcomingAnniversaries = getUpcomingAnniversaries(anniversaries);

  const handleAdd = (newAnniversary) => {
    onAdd({ ...newAnniversary, id: Date.now() });
    setShowAddForm(false);
  };

  return (
    <div className="anniversaries-section">
      <div className="section-header">
        <h2>Special Dates</h2>
        <button className="add-btn" onClick={() => setShowAddForm(true)}>
          <Plus size={18} />
        </button>
      </div>

      {showAddForm && (
        <AddAnniversaryForm
          onAdd={handleAdd}
          onCancel={() => setShowAddForm(false)}
        />
      )}

      {upcomingAnniversaries.length > 0 ? (
        <div className="upcoming-list">
          {upcomingAnniversaries.map(ann => (
            <AnniversaryCard
              key={ann.id}
              anniversary={ann}
              onDelete={onDelete}
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Calendar size={32} opacity={0.3} />
          <p>No anniversaries yet</p>
        </div>
      )}
    </div>
  );
};

export default AnniversariesSection;